(() => {
  'use strict';

  const money = (cents, currency) => {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency', currency: currency || 'USD'
      }).format(Number(cents || 0) / 100);
    } catch (_) {
      return '$' + (Number(cents || 0) / 100).toFixed(2);
    }
  };

  document.querySelectorAll('[data-ls-gift-product]').forEach((root) => {
    if (root.dataset.giftInitialized) return;
    root.dataset.giftInitialized = 'true';

    const form = root.querySelector('form[data-type="add-to-cart-form"]');
    const date = root.querySelector('[data-ls-gift-date]');
    const message = root.querySelector('[data-ls-gift-message]');
    const count = root.querySelector('[data-ls-gift-message-count]');
    const submit = root.querySelector('[data-ls-gift-atc]');
    const feedback = root.querySelector('[data-ls-gift-validation]');
    const error = root.querySelector('.product-form__error-message-wrapper');
    const variantSelect = root.querySelector('[data-ls-gift-variant-select]');
    const variantInput = root.querySelector('[data-ls-gift-variant-id]');
    const variantsScript = root.querySelector('[data-ls-gift-variants]');

    if (!form || !date || !submit) return;

    // Match the V3 product rating behavior without loading Yotpo twice.
    const rating = root.querySelector('[data-ls-gift-reviews-link]');
    const jumpToReviews = (event) => {
      const target = document.querySelector('.section-ls-v3-reviews');
      if (!target) return;
      event.preventDefault();
      event.stopPropagation();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };
    rating?.addEventListener('click', jumpToReviews, true);
    rating?.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') jumpToReviews(event);
    });

    // An empty Yotpo bottomLine widget can reserve a tall, blank block above
    // the price. Keep that space collapsed until an actual rating is present.
    // Observe Yotpo's asynchronous render rather than loading a second widget.
    const ratingWidget = rating?.querySelector('.yotpo.bottomLine');
    if (rating && ratingWidget) {
      const syncRatingVisibility = () => {
        const renderedText = (ratingWidget.textContent || '').replace(/\s+/g, ' ').trim();
        const countMatch = renderedText.match(/([\d,]+)\s*(?:reviews?|ratings?)/i)
          || renderedText.match(/\(([\d,]+)\)/);
        const reviewCount = countMatch ? Number(countMatch[1].replace(/,/g, '')) : 0;
        const show = reviewCount > 0;
        rating.dataset.lsGiftRatingReady = String(show);
        if (show) rating.setAttribute('tabindex', '0');
        else rating.removeAttribute('tabindex');
      };
      syncRatingVisibility();
      const ratingObserver = new MutationObserver(syncRatingVisibility);
      ratingObserver.observe(ratingWidget, { childList: true, characterData: true, subtree: true });
    }

    let variants = [];
    try { variants = JSON.parse(variantsScript?.textContent || '[]'); } catch (_) {}
    const variantById = (id) => variants.find((v) => String(v.id) === String(id));

    const dateString = (day) => [
      day.getFullYear(),
      String(day.getMonth() + 1).padStart(2, '0'),
      String(day.getDate()).padStart(2, '0')
    ].join('-');

    const today = dateString(new Date());
    date.min = today;
    date.max = '2026-12-31';

    const showError = (text) => {
      if (feedback) {
        feedback.textContent = text || '';
        feedback.hidden = !text;
      }
      if (error) error.hidden = true;
    };
    const validateDate = () => {
      if (!date.value) return 'Please select a requested ship date.';
      if (date.value < date.min || date.value > date.max || !date.validity.valid) {
        return 'Please select an available shipping date through December 31, 2026.';
      }
      return '';
    };

    // The gallery owns horizontal swipe navigation. Keep the thumbnail
    // selection in sync with the visible slide just as the V3 gallery does.
    const gallery = root.querySelector('[data-ls-gift-gallery]');
    const slides = [...root.querySelectorAll('[data-ls-gift-slide]')];
    const thumbs = [...root.querySelectorAll('[data-ls-gift-thumbnail]')];
    const prev = root.querySelector('[data-ls-gift-prev]');
    const next = root.querySelector('[data-ls-gift-next]');
    let activeIndex = 0;
    let galleryScrollFrame = null;

    const setActiveSlide = (index) => {
      if (!slides.length) return;
      activeIndex = Math.max(0, Math.min(slides.length - 1, index));
      thumbs.forEach((button, buttonIndex) => {
        const active = buttonIndex === activeIndex;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
      });
      if (prev) prev.disabled = activeIndex === 0;
      if (next) next.disabled = activeIndex === slides.length - 1;
    };

    const scrollToSlide = (index, behavior = 'smooth') => {
      if (!gallery || !slides.length) return;
      const targetIndex = Math.max(0, Math.min(slides.length - 1, index));
      setActiveSlide(targetIndex);
      gallery.scrollTo({ left: targetIndex * gallery.clientWidth, behavior });
    };

    thumbs.forEach((button) => {
      button.addEventListener('click', () => {
        const index = Number(button.dataset.imageIndex);
        if (Number.isInteger(index)) scrollToSlide(index);
      });
    });
    prev?.addEventListener('click', () => scrollToSlide(activeIndex - 1));
    next?.addEventListener('click', () => scrollToSlide(activeIndex + 1));

    gallery?.addEventListener('scroll', () => {
      if (galleryScrollFrame) cancelAnimationFrame(galleryScrollFrame);
      galleryScrollFrame = requestAnimationFrame(() => {
        const width = gallery.clientWidth;
        if (width) setActiveSlide(Math.round(gallery.scrollLeft / width));
      });
    }, { passive: true });
    gallery?.addEventListener('keydown', (event) => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      scrollToSlide(activeIndex + (event.key === 'ArrowRight' ? 1 : -1));
    });
    gallery?.addEventListener('dragstart', (event) => event.preventDefault());

    const initiallySelected = thumbs.find((button) => button.classList.contains('is-active'));
    const initialIndex = initiallySelected ? Number(initiallySelected.dataset.imageIndex) : 0;
    setActiveSlide(initialIndex);
    requestAnimationFrame(() => scrollToSlide(initialIndex, 'instant'));

    const updateVariant = () => {
      const variant = variantById(variantSelect ? variantSelect.value : variantInput?.value);
      if (!variant) return;
      variantInput.value = String(variant.id);
      const current = root.querySelector('[data-ls-gift-current-price]');
      const compare = root.querySelector('[data-ls-gift-compare-price]');
      if (current) current.textContent = money(variant.price, root.dataset.currency);
      if (compare) {
        compare.hidden = !(Number(variant.compare_at_price) > Number(variant.price));
        compare.textContent = compare.hidden ? '' : money(variant.compare_at_price, root.dataset.currency);
      }
      submit.disabled = !variant.available;
      submit.textContent = variant.available ? 'Add to Cart' : 'Sold Out';

      const imageId = variant.featured_image?.id;
      if (imageId) {
        const match = thumbs.find((item) => item.dataset.imageId === String(imageId));
        if (match) scrollToSlide(Number(match.dataset.imageIndex));
      }
    };
    variantSelect?.addEventListener('change', updateVariant);
    updateVariant();

    if (message && count) {
      const updateCount = () => { count.textContent = message.value.length + ' / ' + message.maxLength + ' characters'; };
      message.addEventListener('input', updateCount);
      updateCount();
    }
    // Shop Promise reflects immediate fulfillment, not a future scheduled ship date.
    // Do not show an impossible next-day delivery promise for deferred gift orders.
    const promise = root.querySelector('[data-ls-gift-shop-promise]');
    const syncPromise = () => {
      if (promise) promise.hidden = Boolean(date.value && date.value > date.min);
    };
    date.addEventListener('change', () => {
      showError(validateDate());
      syncPromise();
    });
    syncPromise();

    // Mirror V3's large +/- quantity control while retaining the native
    // named input so Shopify always receives the selected order quantity.
    const qtyInput = root.querySelector('[data-ls-gift-qty]');
    const qtyDecrease = root.querySelector('[data-ls-gift-qty-decrease]');
    const qtyIncrease = root.querySelector('[data-ls-gift-qty-increase]');
    const qtyMin = Number(qtyInput?.min || 1);
    const qtyMax = Number(qtyInput?.max || 99);
    const normalizeQty = () => {
      if (!qtyInput) return 1;
      const raw = Number(qtyInput.value);
      const value = Number.isFinite(raw) ? Math.max(qtyMin, Math.min(qtyMax, Math.trunc(raw))) : qtyMin;
      qtyInput.value = String(value);
      if (qtyDecrease) qtyDecrease.disabled = value <= qtyMin;
      if (qtyIncrease) qtyIncrease.disabled = value >= qtyMax;
      return value;
    };
    qtyDecrease?.addEventListener('click', () => {
      if (!qtyInput) return;
      qtyInput.value = String(normalizeQty() - 1);
      normalizeQty();
      qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
    });
    qtyIncrease?.addEventListener('click', () => {
      if (!qtyInput) return;
      qtyInput.value = String(normalizeQty() + 1);
      normalizeQty();
      qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
    });
    qtyInput?.addEventListener('change', normalizeQty);
    qtyInput?.addEventListener('blur', normalizeQty);
    qtyInput?.addEventListener('input', () => {
      const value = Number(qtyInput.value);
      if (qtyDecrease) qtyDecrease.disabled = !qtyInput.value || value <= qtyMin;
      if (qtyIncrease) qtyIncrease.disabled = Boolean(qtyInput.value) && value >= qtyMax;
    });
    normalizeQty();

    form.addEventListener('submit', async (event) => {
      normalizeQty();
      event.preventDefault();
      if (submit.disabled || submit.dataset.loading === 'true') return;

      const validationError = validateDate();
      if (validationError) {
        showError(validationError);
        date.focus();
        return;
      }
      showError('');
      submit.dataset.loading = 'true';
      submit.disabled = true;
      const previousLabel = submit.textContent;
      submit.textContent = 'Adding...';

      try {
        // A scheduled gift and a normal purchase cannot safely share an order.
        // All gift line items in one checkout must use the same requested date.
        const cartResponse = await fetch((window.routes?.cart_url || '/cart') + '.js', {
          headers: { Accept: 'application/json' },
          credentials: 'same-origin'
        });
        if (!cartResponse.ok) throw new Error('We could not check your cart. Please try again.');
        const cart = await cartResponse.json();
        const items = cart.items || [];
        const hasNonGift = items.some((item) => item.properties?._Holiday_Gift !== 'Yes' && item.properties?.['_Holiday Gift'] !== 'Yes');
        const hasDifferentDate = items.some((item) =>
          item.properties?.['Requested Ship Date'] &&
          item.properties['Requested Ship Date'] !== date.value
        );
        if (hasNonGift) {
          throw new Error('Scheduled gifts need their own checkout. Please complete your regular order first, or empty your cart before adding a gift.');
        }
        if (hasDifferentDate) {
          throw new Error('All gifts in one checkout must share the same requested ship date. Please place a separate order for another date.');
        }

        const data = new FormData(form);
        data.set('properties[_Holiday Gift]', 'Yes');
        data.set('properties[_Gift Card Required]', 'Yes');
        const cartElement = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        const canRender = cartElement && typeof cartElement.renderContents === 'function' &&
          typeof cartElement.getSectionsToRender === 'function';
        if (canRender) {
          data.append('sections', cartElement.getSectionsToRender().map((section) => section.id));
          data.append('sections_url', window.location.pathname);
        }
        const result = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
          method: 'POST',
          body: data,
          credentials: 'same-origin',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
        });
        const payload = await result.json();
        if (!result.ok || payload.status) {
          throw new Error(payload.description || payload.message || 'We could not add this gift to your cart.');
        }
        if (canRender) cartElement.renderContents(payload);
        else window.location.assign(window.routes?.cart_url || '/cart');
      } catch (err) {
        showError(err?.message || 'We could not add this gift. Please try again.');
      } finally {
        delete submit.dataset.loading;
        const variant = variantById(variantInput?.value);
        submit.disabled = variant ? !variant.available : false;
        submit.textContent = submit.disabled ? 'Sold Out' : previousLabel;
      }
    });
  });
})();
